import firebaseService from "./firebase-service";

let analytics = null;

const instance = {
    init: () => {
        if (process.env.NODE_ENV === "UI-TEST" || process.env.NODE_ENV === "development")
            return;

        analytics = firebaseService.getAnalytics();
    },
    logCheckInProcessStartedEvent: () => {
        if (process.env.NODE_ENV === "UI-TEST")
            return;

        analytics.logEvent("check-in started");
    },
    logCheckInProcessCompletedEvent: (outcome) => {
        if (process.env.NODE_ENV === "UI-TEST" || process.env.NODE_ENV === "development")
            return;

        analytics.logEvent("check-in completed", { outcome });
    }
};

export default instance;
